import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import $ from 'jquery';
import browser from '../../../bindings/isMobile-browser';

export const KEYCODE_ESCAPE = 27;

class Popup extends Component {

    constructor(props) {
        super(props);

        this.state = {
            visibility: "hidden"
        };

        this.$anchor = undefined;

        this.additionalClass = "";
        this.showOverlay = false;
        this.afterClosePositionReset = true;
        this.userClosable = true;
        this._debug = false;
        this.allowReopenPopup = true;

        this.popupCloserEvent = browser._userEvent;
        this.popupCloserEvent = "click";
        this.popupCloser = this.popupCloser.bind(this);

        this._onAnimationEnd = this._onAnimationEnd.bind(this);

        this._overlay = document.querySelector('.overlay');
        if (!this._overlay) {
            throw new Error('.overlay element is not found');
        }
        if (typeof this._overlay.getAttribute('refcount') !== 'string') {
            this._overlay.setAttribute('refcount', '0');
        }
    }

    setAnchor(anchor) {
        this.$anchor = $(anchor);
    }

    position() {

    }

    _overlayShow() {
        let refcount = parseInt(this._overlay.getAttribute('refcount'));
        this._overlay.setAttribute('refcount', refcount+1);
        this._overlay.style.display = 'block';
    }

    _overlayHide() {
        let refcount = parseInt(this._overlay.getAttribute('refcount'));
        if (refcount > 1) refcount--;
        else refcount = 0;

        this._overlay.setAttribute('refcount', refcount);
        if (refcount === 0) this._overlay.style.display = 'none';
    }

    popupCloser(event) {
        if (this._debug) console.log('popupCloser()', this._ref.className);

        var $target = $(event.target);

        if ($target.hasClass("popup")) return;
        if ($target.parents(".popup").length) return;
        if ($target.hasClass("popup-opener")) return;
        if ($target.parents(".popup-opener").length) return;

        this.close();
    }

    open(additionalClass) {
        if (this.state.visibility === 'shown' && this.allowReopenPopup) {
            this.close();
            return;
        }

        if (this.showOverlay) this._overlayShow(this.$popup);

        this.position();

        if (additionalClass) {
            this.additionalClass = additionalClass;
            this.$popup.addClass(this.additionalClass);
        }

        this.setState({visibility: 'opening'});
        this._afterOpen();
    }

    close() {
        if (this.state.visibility === 'hiding' || this.state.visibility === 'hidden') return;

        this.setState({visibility: "hiding"});
        if (this.showOverlay) this._overlayHide(this.$popup);

        this._afterClose();
    }

    _afterClose() {
        if (typeof this.props.afterCloseFn === 'function') this.props.afterCloseFn();
    }

    _afterOpen() {
    }

    _onAnimationEnd(event) {
        if (this._debug) console.log('_onAnimationEnd()', this._ref.className);

        switch (event.animationName) {
            case 'popup_opening': this.setState({visibility: 'shown'}); break;
            case 'popup_hiding': this.setState({visibility: 'hidden'}); break;
        }
    }

    componentDidMount() {
        this._ref.addEventListener('animationend', this._onAnimationEnd);

        let popup = this._ref;
        let {anchor} = this.props;

        if (!popup) {
            console.warn("Creating Popup instance with empty _ref: "+popup);
        }

        this.$popup = $(popup);
        if (!this.$popup.length) {
            console.warn("Creating Popup with non-existing popup element: "+popup);
        }

        if (anchor) this.setAnchor(anchor);
    }

    componentWillUpdate(nextProps, nextState) {
        if (this._debug) console.log('componentWillUpdate()', this._ref.className, this.state.visibility, nextState.visibility, this.userClosable);

        if (this.state.visibility === nextState.visibility) return;

        if (nextState.visibility === 'hidden') {
            if (this.afterClosePositionReset) this.$popup.css({left: 0, top: 0});
            // if (this.additionalClass) this.$popup.removeClass(that.additionalClass);
            if (this.userClosable) {
                if (this._debug) console.log('removing popupCloser event handler', this._ref.className);
                // $(document).off(this.popupCloserEvent, this.popupCloser);
                document.removeEventListener(this.popupCloserEvent, this.popupCloser);
            }

        }

        if (nextState.visibility === 'shown') {
            if (this.userClosable) {
                if (this._debug) console.log('adding popupCloser event handler for event: ', this.popupCloserEvent);
                // $(document).on(this.popupCloserEvent, this.popupCloser);
                document.addEventListener(this.popupCloserEvent, this.popupCloser);
            }
        }
    }

    componentWillUnmount() {
        this._ref.removeEventListener('animationend', this._onAnimationEnd);
    }
}

Popup.popups = {};

Popup.initRootElement = function() {
    var rootElement = document.createElement('div');
    rootElement.setAttribute('id', 'popups');
    document.body.appendChild(rootElement);

    Popup._rootElement = rootElement;

    var overlayElement = document.createElement('div');
    overlayElement.className = 'overlay';
    document.body.appendChild(overlayElement);
};

Popup.generateKey = function() {
    throw new Error('generateKey() method must be implemented in Popup component inherited classes')
};

Popup.createRefCallback = function(ref, id, onMount) {
    if (!ref) ref = function(r) {};
    if (!onMount) onMount = function(r) {};

    return function(_ref) {
        if (!_ref) return;
        
        if (typeof _ref.getWrappedInstance == "function") _ref = _ref.getWrappedInstance();

        Popup.registerPopupInstance(id, _ref);

        onMount(_ref);
        ref(_ref);
    }
};

Popup.mount = function(componentClass, props, onMount) {
    if (typeof componentClass.generateKey != 'function') {
        throw new Error('generateKey() method must be implemented in Popup component inherited classes')
    }

    var id = componentClass.generateKey(props);

    var mountElement = Popup._rootElement.querySelector('#'+id);

    if (!mountElement) {
        mountElement = document.createElement('div');
        mountElement.setAttribute('id', id);
        Popup._rootElement.appendChild(mountElement);
    }

   // var element = React.createElement(componentClass, props);
    
    if (!props) props = {}
    props.ref = Popup.createRefCallback(props.ref, id, onMount);
    

    return ReactDOM.render(
        React.createElement(componentClass, props),
        mountElement
    );
};

Popup.unmount = function(componentClass, props) {
    if (typeof componentClass.generateKey != 'function') {
        throw new Error('generateKey() method must be implemented in Popup component inherited classes')
    }

    var id = componentClass.generateKey(props);
    var mountElement = Popup._rootElement.querySelector('#'+id);
    if (mountElement && ReactDOM.unmountComponentAtNode(mountElement)) {
        Popup.unregisterPopupInstance(id);
        return mountElement.parentNode.removeChild(mountElement);
    }

    return false;
};

Popup.registerPopupInstance = function(id, ref) {
    Popup.popups[id] = ref;
    // console.log("Popup.registerPopupInstance()", Popup.popups);
};

Popup.unregisterPopupInstance = function(id) {
    delete Popup.popups[id];
    // console.log("Popup.unregisterPopupInstance()", Popup.popups);
};

export default Popup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/Popup/index.js